import { createSelector } from '@ngrx/store';
import * as fromReducers from '../reducers';
import { HotelRoomResult, hotelRoomResultsAdapter, HotelRoomResultsState } from '../reducers/hotel-room.reducers';

export const getHotelRoomResultsFeatureState = createSelector(
  fromReducers.getTravelSearchState,
  (state: fromReducers.TravelSearchState) => state.hotelRooms
);

export const {
  selectAll: selectRoomResults,
  selectEntities: selectRoomResultEntities,
  selectIds: selectRoomResultIds,
} = hotelRoomResultsAdapter.getSelectors(getHotelRoomResultsFeatureState);

export const getRoomResultBySequenceId = (seqId: number) =>
  createSelector(selectRoomResultEntities, (roomResults) => roomResults[seqId]);

export const getSelectedRooms = () =>
  createSelector(selectRoomResults, (roomResults: HotelRoomResult[]) =>
    roomResults.map((res) => res.selectedRoom).filter((res) => !!res)
  );

export const getRoomResults = createSelector(
  getHotelRoomResultsFeatureState,
  hotelRoomResultsAdapter.getSelectors().selectAll
);

export const getSelectedSupplier = () =>
  createSelector(selectRoomResults, (roomResults: HotelRoomResult[]) => roomResults[0]?.selectedRoom?.supplier);

export const getSelectedProductCode = () =>
  createSelector(selectRoomResults, (roomResults: HotelRoomResult[]) => roomResults[0]?.selectedRoom?.product_code);

export const getIsMoreThanOneRoomSelected = () =>
  createSelector(
    selectRoomResults,
    (roomResults: HotelRoomResult[]) =>
      roomResults.reduce((count: number, room: HotelRoomResult) => {
        return (count += room.selectedRoom ? 1 : 0);
      }, 0) > 1
  );
export const getRoomResultsLoading = createSelector(
  getHotelRoomResultsFeatureState,
  (state: HotelRoomResultsState) => state.loading
);
